<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="姓名">
                    <el-input v-model.trim="filters.empName" clearable placeholder="请输入姓名">
                    </el-input>
                </el-form-item>
                <el-form-item label="医生">
                    <el-select @focus="focus(1)" :filter-method="doctorMatch" filterable remote clearable v-model="filters.doctorName" placeholder="选择医生" multiple>
                        <el-option v-for="(item) in newList1" :key="item.identityName" :label="item.identityName" :value="item.identityName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="护士">
                    <el-select @focus="focus(2)" :filter-method="bbMatch" filterable remote clearable v-model="filters.nurseName" placeholder="选择护士" multiple>
                        <el-option v-for="(item) in newList2" :key="item.identityName" :label="item.identityName" :value="item.identityName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仪器名">
                    <el-input v-model.trim="filters.instrumentName" clearable placeholder="请输入仪器名">
                    </el-input>
                </el-form-item>
                <el-form-item label="院区">
                    <el-select v-model.trim="filters.earId" placeholder="请选择院区" clearable>
                        <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="楼层">
                    <el-select @focus="focusFloor" clearable v-model="filters.sknFloor" placeholder="选择楼层" multiple>
                        <el-option v-for="(item) in floorOptions" :key="item.id" :label="item.floorName" :value="item.floorName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                    <el-button type="warning" @click="exportData" size="small">导出</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="layout-page-box">
            <el-table :cell-style="changeCellStyle" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="sknDate" label="日期"></el-table-column>
                <el-table-column sortable prop="instrumentName" label="仪器名"></el-table-column>
                <el-table-column sortable prop="sknName" label="姓名"></el-table-column>
                <el-table-column sortable prop="instrumentState" label="仪器状况">
                    <template slot-scope="scope">
                        <span>好</span>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="doctorName" label="使用人"></el-table-column>
                <el-table-column sortable prop="nurseName" label="护士"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: "",
    computed: {
        ...mapState(['areaOptions']),
        ...mapGetters(['list1', 'list2', 'areaAndFloorList'])
    },
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                outpatientService: '',
            },
            tableData: [],
            multipleSelection: [],
            tableHeight: '',
            newList1: [],
            newList2: [],
            empId: Lockr.get("skinEmpId"),
            instrumentLog: Lockr.get('instrumentLog'),
            floorOptions: [],
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380

    },
    mounted() {
        /*this.init();*/
        this.$store.dispatch('getIdList')
        this.query(this.filters.pagination.page);

    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        focusFloor() {
            let newArr = this.getArr(this.areaAndFloorList)
            // 给楼层对象赋值
            this.floorOptions = newArr
        },
        getArr(arr) {
            // 获取每一项下的楼层数组
            let time = arr.map(val => {
                return val.floorNameList
            })
            // 二维数组转一维数组
            let newArr = time.flat();
            // 数组去重
            let obj = {};
            newArr = newArr.reduce((cur, next) => {
                obj[next.floorName] ? "" : obj[next.floorName] = true && cur.push(next);
                return cur;
            }, [])
            return newArr
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                doctorName: this.filters.doctorName.toString(),
                nurseName: this.filters.nurseName.toString(),
                sknName: this.filters.sknName,
                sknFloor: this.filters.sknFloor.toString(),
                instrumentName: this.filters.instrumentName,
                earId: this.filters.earId,
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            api.requestQuiet('/skn/findSknInstrumentLogPage', querys, (res) => {
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
        changeCellStyle({ column, columnIndex, row, rowIndex }) {
            // console.log(column, columnIndex, row, rowIndex);
            if (this.instrumentLog == '1') {
                // 医生标识
                if (row.doctorIdentification == 1 && column.property == "doctorName") {
                    return 'color: #FF3B4B'
                }
                // 护士标识
                if (row.nurseIdentification == 1 && column.property == "nurseName") {
                    return 'color: #FF3B4B'
                }
                // 仪器标识
                if (row.instrumentIdentification == 1 && column.property == "instrumentName") {
                    return 'color: #FF3B4B'
                }
            }
        },
        focus(val) {
            if (val == 1) {
                this.newList1 = this.list1
            } else if (val == 2) {
                this.newList2 = this.list2
            }
        },
        doctorMatch(val) {
            this.newList1 = _g.paramMatch(this.list1, this.newList1, val, 'identityName')
        },
        bbMatch(val) {
            this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
        },
        // 导出注射微整科耗材表数据
        exportData() {
            console.log(this.filters.pagination.total);
            let exportUrl = axios.defaults.baseURL;
            var register = {
                total: this.filters.pagination.total,
                startTime: '',
                endTime: '',
                nurseName: this.filters.nurseName.toString(),
                doctorName: this.filters.doctorName.toString(),
                sknName: this.filters.sknName,
                createById: this.empId,
            }
            if (this.filters.startTime) {
                register.startTime = this.filters.startTime[0]
                register.endTime = this.filters.startTime[1]
            }
            var formData = new FormData();
            formData.append("register", JSON.stringify(register))
            this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    axios
                        .post(
                            exportUrl + "skn/excelSknInstrumentLogList", formData, {
                                responseType: "blob",
                            }
                        )
                        .then((res) => {
                            console.log(res)
                            const blob = new Blob([res.data], {
                                type: "application/vnd.ms-excel",
                            });
                            // console.log(blob, '----------0990');
                            const fileName = "仪器使用记录数据.xlsx";
                            const linkNode = document.createElement("a");
                            linkNode.download = fileName; //a标签的download属性规定下载文件的名称
                            linkNode.style.display = "none";
                            linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
                            document.body.appendChild(linkNode);
                            linkNode.click(); //模拟在按钮上的一次鼠标单击
                            URL.revokeObjectURL(linkNode.href); // 释放URL 对象
                            document.body.removeChild(linkNode);
                            this.loading = false;
                        }).catch((err) => {
                            console.log(err.response.data);
                            if (res.response.status == 400) {
                                _g.toast('error', err.response.data.errMsg)
                            }
                        });
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
</style>